import React from "react";

const WorkspaceListShimmer = () => {
  return (
    <div className="p-4 md:flex gap-2">
      <div className="md:w-1/4 rounded-lg h-16 animate-pulse bg-gray-300 my-1"></div>
      <div className="md:w-1/4 rounded-lg h-16 animate-pulse bg-gray-300 my-1"></div>
      <div className="md:w-1/4 rounded-lg h-16 animate-pulse bg-gray-300 my-1"></div>
      <div className="md:w-1/4 rounded-lg h-16 animate-pulse bg-gray-300 my-1"></div>
    </div>
  );
};

export default WorkspaceListShimmer;
